import { IMaterialReducer } from '../Interfaces/IMaterialReducer';
import { materialReducerInitState } from './MaterialInitState';
import { IAction } from '../../../__core/Interfaces/IAction';
import { MaterialResponse } from '../Types/MaterialResponse';
import {
  currentMaterialBase64Reducer,
  currentMaterialReducer,
  materialLoaderReducer,
} from './CurrentMaterial';
import { IEvent } from '../../../__core/Interfaces/IEvent';
import { SideMenuResponse } from '../Types/SideMenuResponse';
import { menuLoaderReducer, menuReducer } from './Menu';
import { IApiJsonResponse } from '../../../__core/Interfaces/IApiResponse';

type MaterialReducerAction =
  | IAction<MaterialResponse>
  | IAction<SideMenuResponse>
  | IEvent;

export const materialReducer = (
  state: IMaterialReducer = materialReducerInitState,
  action: MaterialReducerAction
): IMaterialReducer => ({
  currentMaterial: currentMaterialReducer(
    state.currentMaterial,
    action as IAction<MaterialResponse>
  ),

  fetchMaterialInProgress: materialLoaderReducer(
    state.fetchMaterialInProgress,
    action as IEvent
  ),

  currentMaterialBase64: currentMaterialBase64Reducer(
    state.currentMaterialBase64,
    action as IAction<IApiJsonResponse<string>>
  ),

  menu: menuReducer(state.menu, action as IAction<SideMenuResponse>),

  fetchMenuInProgress: menuLoaderReducer(
    state.fetchMenuInProgress,
    action as IEvent
  ),
});
